package br.com.vvrefeicoes.portal.domain.model

enum class StaffMovementType {
    HIRED,
    TERMINATED,
    TRANSFERRED,
    ACQUIRED,
}

data class StaffMovement(
    val movement: StaffMovementType,
    val role: String,
    val quantity: Int,
)
